import * as actions from '../actions/SavedSearchResultsActions';

const initialState = {
  currentEntityViewName: '',
};

export const getSavedSearchResultsKey = (entityName, searchName, dataKey) => {
  const searchKey = `${entityName}.${searchName}`;
  return dataKey ? `${searchKey}.${dataKey}` : searchKey;
};

function SavedSearchResultsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_SAVED_SEARCH_RESULTS: {
      const { payload } = action;
      const savedSearchKey = getSavedSearchResultsKey(
        payload.entityName,
        payload.searchName,
        payload.dataKey
      );
      const oldValue = state?.[savedSearchKey] ?? {};
      const value = {
        ...oldValue,
        fetching: true,
        error: null,
        searchParams: payload,
      };

      return {
        ...state,
        [savedSearchKey]: value,
      };
    }
    case actions.GET_SAVED_SEARCH_RESULTS_SUCCESS: {
      const { payload } = action;
      const savedSearchKey = getSavedSearchResultsKey(
        payload.entityName,
        payload.searchName,
        payload.dataKey
      );
      const oldValue = state?.[savedSearchKey] ?? {};
      const value = {
        ...oldValue,
        results: payload.results,
        fetching: false,
        error: null,
      };

      return {
        ...state,
        [savedSearchKey]: value,
      };
    }
    case actions.GET_SAVED_SEARCH_RESULTS_FAILURE: {
      const { payload } = action;
      const savedSearchKey = getSavedSearchResultsKey(
        payload.entityName,
        payload.searchName,
        payload.dataKey
      );
      const oldValue = state?.[savedSearchKey] ?? {};
      const value = {
        ...oldValue,
        results: {
          ...oldValue.results,
          rows: [],
        },
        error: payload.error,
        fetching: false,
      };

      return {
        ...state,
        [savedSearchKey]: value,
      };
    }
    case actions.SET_CURRENT_ENTITY_VIEW_NAME: {
      return {
        ...state,
        currentEntityViewName: action.payload,
      };
    }
    case actions.SET_CURRENT_SAVED_SEARCH_NAME: {
      return {
        ...state,
        currentSavedSearchName: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

export default SavedSearchResultsReducer;
